/* eslint-disable @typescript-eslint/no-empty-function */
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { IState } from '@mfe-types/context';
import { CountdownInSeconds } from '@mfe-presentation/constants/userVerification';

export const initialState: IState = {
    stepNames: [],
    maxStepIndex: Infinity,
    maxDisplayedStep: Infinity,
    formValues: {},
    currentStep: {
        name: '',
        index: 0,
        displayedStepNumber: 1,
    },
    config: {},
    cities: [],
    portal: Portal.Immonet,
    logo: undefined as any,
    useShellContext: () => undefined,
    toastMessage: undefined,
    userVerification: {
        isFetching: false,
    },
    estimations: {
        isFetching: false,
        id: '',
        createdAt: '',
        previousEstimationId: '',
        nextEstimationId: '',
        portal: '',
        platform: '',
        isAnUpdate: false,
        valuation: {
            rentMinPrice: 0,
            rentPrice: 0,
            rentMaxPrice: 0,
            rentSqmPrice: 0,
            rentPriceAccuracy: 0,
            rentRequestId: '',
            sellMinPrice: 0,
            sellPrice: 0,
            sellMaxPrice: 0,
            sellSqmPrice: 0,
            sellPriceAccuracy: 0,
            sellRequestId: '',
        },
    },
    isFromUpdatePage: false,
    isAuthenticated: false,
    hasSubmittedCurrentStep: false,
    hasSubmittedPriceEstimateFeedback: false,
    hasUpdatedPhoneNumber: false,
    timer: {
        seconds: CountdownInSeconds,
        startTimer: () => {},
        isTimerRunning: false,
        stopTimer: () => {},
    },
};
